// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"d0378f32","320":"18497d9f","734":"9447c524"}[chunkId] + ".chunk.css";
};